<style>
    body {
        padding-top: 0px !important;
        font-family: 'Nunito Sans' !important;
    }
</style>

<template>
    <keep-alive>
        <router-view/>
    </keep-alive>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        // components: {},
        data() {
            return {
                //        searchTerm: '',
                //        searchResults: []
            };
        },
        mounted() {
            if (this.userCurrentLocation === 'My+Location') {
                this.setUserCurrentLocation();
            }
        },
        watch: {},
        computed: {
            ...mapGetters('dirpesquisador',
                {
                    currentPage: 'getCurrentPage',
                    userCurrentLocation: 'getUserCurrentLocation',
                },
            ),
        },
        methods: {
            ...mapActions('dirpesquisador',
                {
                    setCurrentPage: 'setCurrentPage',
                    setUserCurrentLocation: 'setUserCurrentLocation',
                },
            ),
            /*    ...mapActions('dirpesquisador',
                    {
                        performSearch: 'performSearch',
                    },
                ),
                doSearch() {
                    const self = this;
                    if (this.searchTerm != '')
                        this.performSearch(
                            {
                                search: this.searchTerm
                            }
                        )
                            .then((response) => {
                                console.log(response);
                                self.searchResults = response.list;
                            })
                            .catch((error) => {
                            });
                } */
            /*
geolocate() {
navigator.geolocation.getCurrentPosition(this.buildUrl, this.geoError);
},
buildUrl(position) {
const lat = position.coords.latitude;
const lon = position.coords.longitude;
self.setUserCurrentLocation(lat + ',' + lon);
//window.open('https://www.google.com/maps?saddr=' + lat + ',' + lon  + '&daddr=' +
this.resultado.morada + ' ' + this.resultado.cp4 + '-' + this.resultado.cp3 + ' '
+ this.resultado.localidade, "_blank");
},
geoError(error) {
self.setUserCurrentLocation('My+Location');
//window.open('https://www.google.com/maps?saddr=My+Location&daddr=' + this.resultado.morada + ' ' +
this.resultado.cp4 + '-' + this.resultado.cp3 + ' ' + this.resultado.localidade, "_blank");
},                          */

        },
    };
</script>